










import { Vue, Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import InstallAlert from "@/components/InstallAlert.vue";
import AuthAlert from "@/components/AuthAlert.vue";
import CamtelYoomeeAlert from "@/components/CamtelYoomeeAlert.vue";
import DstvOrderAlert from "@/components/DstvOrderAlert.vue";
@Component({
    components: { DstvOrderAlert, CamtelYoomeeAlert, AuthAlert, InstallAlert },
})
export default class CompositeAlert extends Vue {
    @Getter("canInstallApp") canInstallApp!: boolean;
    @Getter("user") user!: boolean;

    get shouldShow(): boolean {
        return (
            this.canInstallApp ||
            !this.user ||
            this.$route.name === this.$constants.ROUTE_NAMES.AIRTIME_INDEX ||
            this.$route.name === this.$constants.ROUTE_NAMES.DSTV_INDEX
        );
    }
}
